// Vendor
import { Component } from "@angular/core";

@Component({
    selector: "ig-step2",
    templateUrl: "./step2.component.html",
    styleUrls: ["./step2.component.scss"],
})
export class Step2Component {
    //
}
